import { HorizontalRule } from 'components/Layout';

export const Hr = () => <HorizontalRule mx={0} my={4} />;
